
const PROD_ORIGIN = 'https://www.agmvision.com'

export default {
  name: 'ProductVideoPreview',
  props: {
    src: {
      type: String,
      required: true,
    },
    poster: {
      type: String,
      default: null,
    },
    active: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      visible: false,
      observer: null,
    }
  },
  computed: {
    playableSrc() {
      if (process.env.NODE_ENV !== 'production' && this.src.startsWith('/')) {
        return PROD_ORIGIN + this.src
      }
      return this.src
    },
  },
  watch: {
    active() {
      this.sync()
    },
  },
  mounted() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return
    if (!('IntersectionObserver' in window)) return
    this.observer = new IntersectionObserver(
      ([entry]) => {
        this.visible = entry.isIntersecting && entry.intersectionRatio >= 0.5
        this.sync()
      },
      { threshold: [0, 0.5] }
    )
    this.observer.observe(this.$el)
  },
  beforeDestroy() {
    if (this.observer) this.observer.disconnect()
  },
  methods: {
    sync() {
      const video = this.$refs.video
      if (!video) return
      if (this.visible && this.active) {
        const playing = video.play()
        if (playing && playing.catch) playing.catch(() => {})
      } else {
        video.pause()
      }
    },
  },
}
